import { useMemo } from 'react';

import { Environment } from '@gbm/onboarding-sdk-utils';
import Auth from '../auth';

export default function useAuthApi(environment: Environment) {
  return useMemo(() => new Auth(environment), [environment]);
}
